import Logo from './../../assets/img/CV-logo.svg';

const Footer= () => {

  return (
  <footer className="footerclass bg-mild-green py-5 mt-5">
    <div className="container py-5">
      <div className="logo d-flex justify-content-center"><img src={Logo} alt="Casinos Vergleich Logo" width="55" height="53" ></img></div>
      <div className="footer-nav flex-column flex-sm-row d-flex align-items-center justify-content-sm-center mt-3">
        <a href="/impressum" className="text-decoration-none fw-bold text-dark">Impressum</a>
        <span className="d-none d-sm-inline-flex fw-bold mx-1">|</span>
        <a href="/datenschutz" className="text-decoration-none fw-bold text-dark">Datenschutz</a>
        <span className="d-none d-sm-inline-flex fw-bold mx-1">|</span>
        <a href="/transparenz-hinweis" className="text-decoration-none fw-bold text-dark">Transparenz-Hinweis</a>
      </div>
    </div>
  </footer>
  );
}

export default Footer;